import { Injectable } from '@angular/core';

import { RestService } from "../../../core/services/rest.service";
import {Servico, ServicoBem, ServicoPlano} from "./servico.model";
import {apiName, servicoBensApiName, servicoPlanosApiName, servicoOrdensServicoApiName} from "./data.service";

@Injectable()
export class ServicoApiService {

    constructor(
        private _restService: RestService
    ) { }

    onPost(object: Servico, done: any) {
        this._restService.onPost(apiName, object, done);
    }

    onPut(object: Servico, done: any) {
        this._restService.onPut(apiName, object, done);
    }

    onDelete(objectId: number, done: any) {
        this._restService.onDelete(apiName, objectId, done);
    }

    onGetAll(done: any) {
        let filter: any = {"order":"descricao"};
        this._restService.onGetPost(apiName, filter, done);
    }

    onGetById(objectId: number, done: any) {
        this._restService.onGetPostId(apiName, objectId, {}, done);
    }

    onGetWithMateriais(done: any) {
        this._restService.onGetPostCustom(apiName + '/populado', {}, done);//busca servicos populado com materiais
    }

    onGetApiUrl() {
        return apiName;
    }

    //servicos planos
    onPostServicoPlano(object: ServicoPlano, done: any) {
        this._restService.onPost(servicoPlanosApiName, object, done);
    }

    onPutServicoPlano(object: ServicoPlano, done: any) {
        this._restService.onPut(servicoPlanosApiName, object, done);
    }

    onDeleteServicoPlano(objectId: number, done: any) {
        this._restService.onDelete(servicoPlanosApiName, objectId, done);
    }

    onGetAllServicoPlano(done: any) {
        let filter: any = {"include":["plano","servico"]};
        this._restService.onGetPost(servicoPlanosApiName, filter, done);
    }

    onGetByIdServicoPlano(objectId: number, done: any) {
        let filter:any = {"include":["plano","servico"]};
        this._restService.onGetPostId(servicoPlanosApiName, objectId, filter, done);
    }

    onGetByPlanoServicoPlano(planoId: number, done: any) {
        let filter: any = {"where":{"planoId":planoId},"include":["servico"]};
        this._restService.onGetPost(servicoPlanosApiName, filter, done);
    }

    //servicos bens
    onPostServicoBem(object: ServicoBem, done: any) {
        this._restService.onPost(servicoBensApiName, object, done);
    }

    onPostServicosBem(object: ServicoBem, done: any) {
        this._restService.onPostCustom(servicoBensApiName + '/bulk', object, done);
    }

    onPutServicoBem(object: ServicoBem, done: any) {
        this._restService.onPut(servicoBensApiName, object, done);
    }

    onDeleteServicoBem(objectId: number, done: any) {
        this._restService.onDelete(servicoBensApiName, objectId, done);
    }

    onGetByBemServicoBem(bemId: number, done: any) {
        let filter: any = {"where":{"bemId":bemId},"include":["servico",{"plano":["marca","categoria"]}]};
        this._restService.onGetPost(servicoBensApiName, filter, done);
    }

    onGetByIdServicoBem(objectId: number, done: any) {
        let filter: any = {"include":["servico","bem"]};
        this._restService.onGetPostId(servicoBensApiName, objectId, filter, done);
    }

    onDeleteServicosBem(list: any[], done: any) {
        this._restService.onPostCustom(servicoBensApiName + "/remover-lista", list, done);
    }

    //servicos ordens servico
    onPostServicoOrdemServico(object: ServicoPlano, done: any) {
        this._restService.onPost(servicoOrdensServicoApiName, object, done);
    }

    onPutServicoOrdemServico(object: ServicoPlano, done: any) {
        this._restService.onPut(servicoOrdensServicoApiName, object, done);
    }

    onDeleteServicoOrdemServico(objectId: number, done: any) {
        this._restService.onDelete(servicoOrdensServicoApiName, objectId, done);
    }

    onGetAllServicoOrdemServico(done: any) {
        let filter: any = {"include":["medida","servico","ordemServico"]};
        this._restService.onGetPost(servicoOrdensServicoApiName, filter, done);
    }

    onGetByIdServicoOrdemServico(objectId: number, done: any) {
        let filter: any = {"include":["medida","servico","ordemServico"]};
        this._restService.onGetPostId(servicoOrdensServicoApiName, objectId, filter, done);
    }

    onPostServicosOrdemServico(servicos: any, done: any) {
        this._restService.onPostCustom(servicoOrdensServicoApiName + '/bulk', servicos, done);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/servicos/shared/servico-api.service.ts
 **/